import PropTypes from 'prop-types';

import { legacyTheme, styled } from '@prose-ui/legacy';

import { Button } from 'Components/LegacyButton';
import Spacer from 'Components/Spacer';
import { Typography } from 'Components/Typography';

import useResponsiveVariant from 'utils/useResponsiveVariant';

const Wrapper = styled.div`
  padding: 72px 30px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;

  ${legacyTheme.breakpoints.up('md')} {
    align-items: center;
    padding: 120px;
  }
`;

const StyledButton = styled(Button)`
  width: 270px;
  ${legacyTheme.breakpoints.up('md')} {
    width: 375px;
  }
`;

const ReportBlock = ({ button, title }) => {
  const { isMobile } = useResponsiveVariant();
  return (
    <Wrapper>
      <Typography markupName="h2" variant="h1">
        {title}
      </Typography>
      <Spacer size={isMobile ? 20 : 35} />
      <StyledButton
        Component="a"
        data-click="download"
        data-from="Report-Module"
        href={button.href}
        target="_blank"
        variant="vertFull"
      >
        {button.label}
      </StyledButton>
    </Wrapper>
  );
};

ReportBlock.propTypes = {
  title: PropTypes.string.isRequired,
  button: PropTypes.shape({ label: PropTypes.string.isRequired, href: PropTypes.string.isRequired })
    .isRequired,
};

export default ReportBlock;
